export default "__VITE_ASSET__Vu4AqXBk__"